const { endOfDay, startOfDay, format } = require('date-fns');
import timesheetbrTemplate from './timesheetbr.html';

angular
   .module('org.saga.widget.timesheetbr', ['org.saga.service', 'org.saga.newtimesheetrecord'])
   .filter('getLabel', [
      '$parse',
      function ($parse) {
         return function (item, labelExpression) {
            if (!labelExpression) {
               return item;
            }
            const parsedExpression = $parse(labelExpression);
            return parsedExpression({ item: item });
         };
      }
   ])
   .filter('dynamicExpFilter', [
      '$parse',
      function ($parse) {
         return function (items, filterExpression) {
            if (!filterExpression) {
               return items;
            }
            const parsedExpression = $parse(filterExpression);
            return items.filter((item) => {
               return parsedExpression({ item: item });
            });
         };
      }
   ])
   .directive('timesheetbrWidget', [
      'PropertiesLoader',
      '$translate',
      'InstanceExpression',
      'Timesheet',
      'TimesheetVendor',
      '$http',
      function (PropertiesLoader, $translate, InstanceExpression, Timesheet, TimesheetVendor) {
         return {
            restrict: 'E',
            require: '^form',
            controllerAs: 'ctrl',
            template: timesheetbrTemplate,
            scope: {
               widget: '=',
               editable: '=',
               instance: '=',
               required: '=',
               output: '=?'
            },
            link: function (scope, element, attrs, form) {
               scope.form = form;
            },
            controller: [
               '$scope',
               '$parse',
               '$mdDialog',
               'DefaultProperties',
               'NewTimesheetRecordDialog',
               function ($scope, $parse, $mdDialog, DefaultProperties, NewTimesheetRecordDialog) {
                  PropertiesLoader.load($scope, DefaultProperties.timesheetbr);

                  const Service = $scope.vendorMode ? TimesheetVendor : Timesheet;

                  function getValueFromAttribute(attribute) {
                     if (typeof attribute === 'string') {
                        return InstanceExpression.eval(attribute, $scope.instance);
                     } else {
                        return attribute;
                     }
                  }

                  $scope.positions = getValueFromAttribute($scope.positions);
                  $scope.projects = getValueFromAttribute($scope.projects);
                  $scope.artifacts = getValueFromAttribute($scope.artifacts);
                  $scope.activities = getValueFromAttribute($scope.activities);
                  $scope.minDateObject = getValueFromAttribute($scope.minDate);
                  $scope.maxDateObject = getValueFromAttribute($scope.maxDate);
                  $scope.reporterEmailValue = getValueFromAttribute($scope.reporterEmail);

                  function formatDateTime(date) {
                     return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS");
                  }

                  function getReporterRecords() {
                     const dateFrom = formatDateTime(startOfDay($scope.minDateObject));
                     const dateTo = formatDateTime(endOfDay($scope.maxDateObject));
                     const payload = {
                        timeFrom: dateFrom,
                        timeTo: dateTo
                     };

                     if ($scope.vendorMode && !$scope.reporterEmailValue) {
                        $scope.output = [];
                        return;
                     }

                     if ($scope.vendorMode) {
                        payload.reporterEmail = $scope.reporterEmailValue;
                     }

                     Service.find(payload)
                        .$promise.then(function (response) {
                           const sortedData = response.sort((a, b) => {
                              const dateA = new Date(a.timeFrom);
                              const dateB = new Date(b.timeFrom);
                              return dateB - dateA; // Sort in descending order
                           });
                           $scope.output = angular.copy(sortedData);
                           $scope.reloadKey = Date.now(); // Force re-render of ng-repeat
                           setTotalMandays();
                        })
                        .catch(function (error) {
                           $scope.output = [];
                           setTotalMandays();
                        });
                  }

                  getReporterRecords();

                  function setTotalMandays() {
                     $scope.totalManDays = $scope.output.reduce(
                        (acc, timesheet) => acc + timesheet.mandays,
                        0
                     );
                  }

                  $scope.properties = [
                     $scope.activityLabelExpression,
                     $scope.activities,
                     $scope.artifactLabelExpression,
                     $scope.artifacts,
                     $scope.labels,
                     $scope.maxDateObject,
                     $scope.minDateObject,
                     $scope.positionLabelExpression,
                     $scope.positions,
                     $scope.projectLabelExpression,
                     $scope.projects
                  ];

                  $scope.showAddRecordDialog = function () {
                     NewTimesheetRecordDialog.show(
                        ...$scope.properties,
                        {},
                        $scope.output,
                        false,
                        (record) => $scope.formatAndSave(record)
                     );
                  };

                  $scope.deleteRecord = function (recordId) {
                     const data = $scope.vendorMode
                        ? [
                             {
                                timesheetRowId: recordId
                             }
                          ]
                        : {
                             id: recordId
                          };

                     Service.delete(data)
                        .$promise.then(function () {
                           getReporterRecords();
                        })
                        .catch(function (error) {
                           $mdDialog.show(
                              $mdDialog
                                 .alert()
                                 .clickOutsideToClose(true)
                                 .title($translate.instant('TimesheetDeleteErrorTitle'))
                                 .textContent(
                                    $translate.instant('TimesheetDeleteErrorMessage') +
                                       '\n' +
                                       error.data.message
                                 )
                                 .ok($translate.instant('Ok'))
                           );
                        });
                  };

                  function createCopyOfRecord(recordToCopy) {
                     const record = angular.copy(recordToCopy);
                     const project = $scope.projects.find(
                        (project) => project.projectId === record.projectId
                     );
                     const artifact = $scope.artifacts.find(
                        (artifact) => artifact.artifactId === record.artifactId
                     );
                     const position = $scope.positions.find(
                        (position) => position.positionId === record.positionId
                     );
                     const activity = $scope.activities.find(
                        (activity) => activity.activityId === record.activityId
                     );

                     return {
                        date: new Date(record.date),
                        timeFrom: new Date(record.timeFrom),
                        timeTo: new Date(record.timeTo),
                        activity: activity,
                        artifact: artifact,
                        project: project,
                        position: position,
                        description: record.activityDescription,
                        links: record.linkToOutput,
                        timesheetRowId: record.timesheetRowId
                     };
                  }

                  $scope.editRecord = function (record, recordKey) {
                     const recordToEdit = createCopyOfRecord(record);
                     const copy = angular.copy($scope.output);
                     const spliced = copy.toSpliced(recordKey, 1);

                     NewTimesheetRecordDialog.show(
                        ...$scope.properties,
                        recordToEdit,
                        spliced,
                        true,
                        (newRecord) => {
                           const data = createUploadData(newRecord);
                           Service.update(data)
                              .$promise.then(function () {
                                 getReporterRecords();
                              })
                              .catch(function (error) {
                                 $mdDialog.show(
                                    $mdDialog
                                       .alert()
                                       .clickOutsideToClose(true)
                                       .title($translate.instant('TimesheetSaveErrorTitle'))
                                       .textContent(
                                          $translate.instant('TimesheetSaveErrorMessage') +
                                             '\n' +
                                             error.data.message
                                       )
                                       .ok($translate.instant('Ok'))
                                 );
                              });
                        }
                     );
                  };

                  $scope.duplicateRecord = function (recordToDuplicate) {
                     const newRecord = createCopyOfRecord(recordToDuplicate);

                     NewTimesheetRecordDialog.show(
                        ...$scope.properties,
                        newRecord,
                        $scope.output,
                        true,
                        (record) => $scope.formatAndSave(record)
                     );
                  };

                  function createUploadData(record) {
                     let data = {
                        date: format(record.date, 'yyyy-MM-dd'),
                        timeFrom: formatDateTime(record.timeFrom),
                        timeTo: formatDateTime(record.timeTo),
                        projectId: record.project.projectId,
                        projectName: record.project.displayName,
                        positionId: record.position.positionId,
                        positionMPSV: record.position.positionMpsvName[0].value,
                        activityId: record.activity.activityId,
                        activityName: record.activity.activity,
                        activityDescription: record.description,
                        linkToOutput: record.links,
                        artifactId: record.artifact.artifactId,
                        artifactName: record.artifact.artifactName,
                        timesheetRowId: record.timesheetRowId,
                        contractId: record.position.contractId[0]?.value,
                        contractName: record.position.contractName[0]?.value
                     };

                     if ($scope.vendorMode) {
                        data.reporterEmail = $scope.reporterEmailValue;
                        data = [data];
                     }

                     return data;
                  }

                  $scope.formatAndSave = function (record) {
                     const data = createUploadData(record);

                     Service.create(data)
                        .$promise.then(function () {
                           getReporterRecords();
                        })
                        .catch(function (error) {
                           $mdDialog.show(
                              $mdDialog
                                 .alert()
                                 .clickOutsideToClose(true)
                                 .title($translate.instant('TimesheetSaveErrorTitle'))
                                 .textContent(
                                    $translate.instant('TimesheetSaveErrorMessage') +
                                       '\n' +
                                       error.data.message
                                 )
                                 .ok($translate.instant('Ok'))
                           );
                        });
                  };

                  $scope.getDotClass = function (value) {
                     if (value?.decision === 'APPROVED') return 'dot-green';
                     if (value?.decision === 'DENIED') return 'dot-red';
                     return 'dot-grey';
                  };
               }
            ]
         };
      }
   ]);
